import {
  checklistTemplateKeys,
  checklistTemplateEditorMutationKeys,
  RequestTypes,
} from '@core/react-query/features/templates/checklistTemplates'
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { ChecklistTemplateRole } from '@core/entities/checklist/ChecklistTemplateRoles/ChecklistTemplateRole'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useCreateChecklistTemplateRole = (
  options?: UseMutationOptions<
    ChecklistTemplateRole,
    RequestErrorType,
    RequestTypes['createChecklistTemplateRole']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...checklistTemplateEditorMutationKeys.createTemplateRole,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: checklistTemplateKeys.getRoles._def,
      })
    },
  })
}
